import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Layout.css';

const IconGrid = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <rect x="1" y="1" width="6" height="6" rx="1" fill="currentColor" opacity=".7"/>
    <rect x="9" y="1" width="6" height="6" rx="1" fill="currentColor" opacity=".7"/>
    <rect x="1" y="9" width="6" height="6" rx="1" fill="currentColor" opacity=".7"/>
    <rect x="9" y="9" width="6" height="6" rx="1" fill="currentColor" opacity=".7"/>
  </svg>
);

const IconFolder = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M1.5 3.5C1.5 2.948 1.948 2.5 2.5 2.5H6l1.5 1.5H13.5c.552 0 1 .448 1 1v7c0 .552-.448 1-1 1h-11c-.552 0-1-.448-1-1V3.5z" fill="currentColor" opacity=".7"/>
  </svg>
);

const IconSun = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/>
    <line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
    <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/>
    <line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
    <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
  </svg>
);

const IconMoon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
  </svg>
);

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [darkMode, setDarkMode] = useState(false);

  const handleLogout = () => { logout(); navigate('/login'); };

  return (
    <div className="layout">
      <aside className="sidebar">
        <div className="sidebar-top">
          <div className="sidebar-logo">
            <img src="/logo-neg.png" alt="ARmundi" />
          </div>
          <nav className="sidebar-nav">
            <NavLink to="/" end className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
              <IconGrid /> <span>Übersicht</span>
            </NavLink>
            <NavLink to="/projects" className={({ isActive }) => isActive ? 'nav-item active' : 'nav-item'}>
              <IconFolder /> <span>Projekte</span>
            </NavLink>
          </nav>
        </div>

        <div className="sidebar-bottom">
          <button
            className="dark-toggle"
            onClick={() => setDarkMode(d => !d)}
            title={darkMode ? 'Hellmodus' : 'Dunkelmodus'}
          >
            {darkMode ? <IconSun /> : <IconMoon />}
            <span>{darkMode ? 'Hell' : 'Dunkel'}</span>
          </button>

          {user && (
            <div className="sidebar-user">
              <div className="user-avatar">
                {(user.name || user.email || '?').charAt(0).toUpperCase()}
              </div>
              <div className="user-info">
                <span className="user-name">{user.name || user.email}</span>
                <span className="user-org">{user.organisation?.name}</span>
              </div>
            </div>
          )}

          <button className="logout-btn" onClick={handleLogout}>
            Abmelden
          </button>
        </div>
      </aside>

      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}
